module.exports = __webpack_public_path__ + "img/404.2d6a0b26.svg";